"use client";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  useTheme,
} from "@mui/material";
import React from "react";
import ButtonComponent from "./Button";

const CardComponent = ({
  children,
  title = "",
  image,
  imageName,
  CardActionsReqd = true,
  width = "250px",
  height ="250px"
}) => {
  const theme = useTheme();
  return (
    <Card elevation={9} sx={{ minWidth: "300px", m: 1, width:[width], height:[height] }}>
      {title && (
        <CardHeader
          title={title}
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.pale.main,
          }}
        />
      )}
      <CardContent>{children}</CardContent>
      {image && <CardMedia component="img" image={image} alt={imageName} />}
      {CardActionsReqd && (
        <CardActions>
          <ButtonComponent type="reset">Cancel</ButtonComponent>
          <ButtonComponent type="submit">Submit</ButtonComponent>
        </CardActions>
      )}
    </Card>
  );
};

export default CardComponent;
